import React from 'react';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DatagridLoader from '../elements/datagrid-loader.element';

interface AdminGridWidgetProps {
  columns: any[];
  rows: any[];
  pageSize?: number;
  onPageChange?: (newPage: number) => void;
  loading?: boolean;
  page?: number;
  totalRows?: number;
}

const AdminGridWidget: React.FC<AdminGridWidgetProps> = ({
  columns,
  rows,
  pageSize = 20,
  onPageChange,
  loading = false,
  page = 1,
  totalRows = 0,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns.map((col) => ({ ...col, sortable: false }))}
        pageSizeOptions={[pageSize]}
        paginationMode="server"
        paginationModel={{ page, pageSize }}
        rowCount={totalRows}
        onPaginationModelChange={(newModel: any) => onPageChange?.(newModel.page + 1)}
        loading={loading}
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        slots={{
          loadingOverlay: DatagridLoader,
        }}
        sx={{
          // '& .MuiDataGrid-row': {
          //   maxHeight: 'inherit !important',
          //   '--height': '75px !important',
          // },
          '& .item-img-cell': {
            display: 'flex',
          },
        }}
      />
    </Box>
  );
};

export default AdminGridWidget;
